function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_34_4",
  "data-name": "Component 34 \\u2013 4",
  transform: "translate(2.121 2.121)"
}, /*#__PURE__*/React.createElement("line", {
  className: "arrow",
  id: "Line_10",
  "data-name": "Line 10",
  x1: 17.719,
  transform: "translate(0.281 7.42)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  className: "arrow",
  id: "Line_11",
  "data-name": "Line 11",
  x2: 7.42,
  y2: 7.421,
  transform: "translate(7.421) rotate(90)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  className: "arrow",
  id: "Line_12",
  "data-name": "Line 12",
  y1: 7.421,
  x2: 7.42,
  transform: "translate(7.421 7.42) rotate(90)",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 3
}));

var SvgGoback = function SvgGoback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.621,
    height: 19.083,
    viewBox: "0 0 21.621 19.083",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/goback.df17d964.svg";
export { ForwardRef as ReactComponent };